if(!customElements.get('swym-header-icon')){
  class SwymHeaderIcon extends HTMLElement{
      constructor(){
        super();
        if (!window.SwymCallbacks) window.SwymCallbacks = [];
        window.SwymCallbacks.push(this._initializeSwymButton.bind(this));
      }

      async _initializeSwymButton(swat){
        // this.button = this.querySelector('button');
        // this.button.addEventListener('click', _openWishlistUi);

        // function _openWishlistUi(evt){
        //   swat.ui.open();
        // }

        // HEADER COUNTER CODE
        this.counter = this.querySelector("#swym-wishlist-count");
        if(this.counter){
          async function getListsData(){
            return new Promise(async (resolve, reject) => {
              swat.fetchLists({
                callbackFn: data => resolve(data),
                onError: error => reject(error)
              })
            })
          }
          const listData = await getListsData();

          let products = {};
          for (const list of listData) {
            for (const product of list.listcontents) {
                const epi = product.epi;
                if (!products[epi]) {
                  products[epi] = product;
                }
              }
            }
            this.counter.innerHTML = Object.values(products).length || '';
          }

          swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
            const current = this.counter.innerHTML;
            const newCount = Number(current) + 1;
            this.counter.innerHTML = newCount;
          });

          swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => {
            const current = this.counter.innerHTML;
            const newCount = Number(current) - 1;
            this.counter.innerHTML = newCount || '';
          });
      }
  }

  customElements.define('swym-header-icon', SwymHeaderIcon);
}




if(!customElements.get('swym-wishlist-count')){
  class SwymWishlistCount extends HTMLElement{
    constructor(){
      super();
      if (!window.SwymCallbacks) window.SwymCallbacks = [];
      window.SwymCallbacks.push(this._initializeSwymButton.bind(this));
    }

    async _initializeSwymButton(swat){
        this.productCounter = this.querySelectorAll(".swym-wishlist-product-count");
        let productId = this.dataset.productId;
        if(this.productCounter && productId){
          // Define the product object
          let product = {
            empi: productId // id of the product
          };


          async function getSocialCount(){
            return new Promise(async (resolve, reject) => {
              swat.wishlist.getSocialCount(product, data => resolve(data), error => reject(error));
            })
          }
          const response = await getSocialCount();
          let count = response.data.count;

          this.productCounter.forEach(counter => {
            if (counter.classList.contains('swym-button')) {
              counter.innerHTML = count > 0 ? `(${count})` : '';
            } else {
              counter.innerHTML = count > 0 ? count : '';
            }
          });

          swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
            this.productCounter.forEach(counter => {
              const current = counter.innerHTML.replace(/[()]/g, '') || 0;
              const newCount = Number(current) + 1;
              if (counter.classList.contains('swym-button')) {
                counter.innerHTML = `(${newCount})`;
              } else {
                counter.innerHTML = newCount;
              }
            });
          });

          swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => {
            this.productCounter.forEach(counter => {
              const current = counter.innerHTML.replace(/[()]/g, '') || 0;
              const newCount = current > 0 ? Number(current) - 1 || 0 : 0;
              if (counter.classList.contains('swym-button')) {
                counter.innerHTML = newCount > 0 ? `(${newCount})` : '';
              } else {
                counter.innerHTML = newCount || '';
              }
            });
          });
      }
    }
  }

  customElements.define('swym-wishlist-count', SwymWishlistCount);
}

// TODO https://support.getswym.com/support/solutions/articles/9000229439-installing-the-swym-wishlist-feature-on-your-shopify-dev-theme
if (!window.SwymCallbacks) window.SwymCallbacks = [];

window.SwymCallbacks.push(function(swat) {
  const isMobile = () => window.innerWidth <= 767;
  
  let wishlistProductIds = new Set();
  
  async function updateWishlistState() {
    try {
      const lists = await new Promise((resolve, reject) => {
        swat.fetchLists({
          callbackFn: data => resolve(data),
          onError: error => reject(error)
        });
      });
      
      wishlistProductIds.clear();
      lists.forEach(list => {
        list.listcontents.forEach(item => {
          wishlistProductIds.add(String(item.empi));
        });
      });
    } catch (error) {
      console.log('Error fetching wishlist:', error);
    }
  }
  
  updateWishlistState();
  
  let lastActionProductId = null;
  let lastActionWasAdd = false;
  
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.swym-add-to-wishlist');
    if (btn && isMobile()) {
      lastActionProductId = btn.dataset.productId;
      lastActionWasAdd = !wishlistProductIds.has(String(lastActionProductId));
    }
  }, true);
  
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, async function(e) {
    if (!isMobile()) return;
    
    const addedProductId = e.detail?.epi || e.detail?.empi;
    if (addedProductId) {
      wishlistProductIds.add(String(addedProductId));
    }
    
    await updateWishlistState();
    
    setTimeout(() => {
      const allButtons = document.querySelectorAll('.swym-add-to-wishlist');
      allButtons.forEach(btn => {
        const btnProductId = String(btn.dataset.productId);
        
        if (wishlistProductIds.has(btnProductId)) {
          if (!btn.classList.contains('swym-added')) {
            btn.classList.add('swym-added');
          }
        } else {
          btn.classList.remove('swym-added');
        }
      });
    }, 100);
  });
  
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, async function(e) {
    if (!isMobile()) return;
    
    const removedProductId = e.detail?.epi || e.detail?.empi;
    if (removedProductId) {
      wishlistProductIds.delete(String(removedProductId));
    }
    
    await updateWishlistState();
    
    setTimeout(() => {
      const allButtons = document.querySelectorAll('.swym-add-to-wishlist');
      allButtons.forEach(btn => {
        const btnProductId = String(btn.dataset.productId);
        
        if (wishlistProductIds.has(btnProductId)) {
          if (!btn.classList.contains('swym-added')) {
            btn.classList.add('swym-added');
          }
        } else {
          btn.classList.remove('swym-added');
        }
      });
    }, 100);
  });
});